import { Graphics } from 'pixi.js';
import { type System, ComponentStore } from '@ecs/world';
import type { ExplosionComponent, TimeScaleResource } from '@game/scenes/characterPrototype/types';
import { clamp } from '@game/scenes/characterPrototype/math';

export function createExplosionSystem(
	explosions: ComponentStore<ExplosionComponent>,
	graphics: ComponentStore<Graphics>
): System {
	return ({ delta, world }) => {
		const timescale = world.getResource<TimeScaleResource>('timescale') ?? ({ value: 1 } as TimeScaleResource);
		const dt = delta * timescale.value;
		const toRemove: number[] = [];
		explosions.forEach((explosion, entity) => {
			explosion.elapsed += dt;
			const t = clamp(explosion.elapsed / explosion.duration, 0, 1);
			const scale = explosion.startRadius + (explosion.endRadius - explosion.startRadius) * t;
			const g = graphics.get(entity);
			if (g) {
				g.scale.set(scale);
				g.alpha = 1 - t;
			}
			if (explosion.elapsed >= explosion.duration) {
				toRemove.push(entity);
			}
		});
		for (const id of toRemove) {
			const g = graphics.get(id);
			if (g) {
				g.parent?.removeChild(g);
				g.destroy();
			}
			world.destroyEntity(id);
		}
	};
}


